import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAuthDetailsUIModel, IEgressEventMappingModel, IExceptionModel, IIngressEventMappingModel, IServiceDetailsUIModel, IServiceOperation } from '../../../models';

export interface ISaveAsDraftInitialState {
  serviceData: IServiceDetailsUIModel,
  serviceOperations: IServiceOperation[],
  serviceExceptions?: IExceptionModel[],
  ingressEvent: IIngressEventMappingModel[],
  egressEvent: IEgressEventMappingModel[],
}

const serviceDetails: IServiceDetailsUIModel = {
  serviceName: '',
  endPoint: '',
  serviceType: '',
  serviceDescription: '',
  checkClicked: false,
  authDetails: {},
  soapAttributes: {},
  importStatus: false
};
const initialState: ISaveAsDraftInitialState = {
  serviceData: serviceDetails,
  serviceOperations: [],
  serviceExceptions: [],
  ingressEvent: [],
  egressEvent: [],
};

const SaveAsDraftDetailsSlice = createSlice({
  name: 'exceptionDetails',
  initialState,

  reducers: {
    addSaveAsDraft: (state, action: PayloadAction<ISaveAsDraftInitialState>) => {
      const autModel: IAuthDetailsUIModel = {
        authMethod: action.payload.serviceData.authDetails?.authMethod,
        authType: action.payload.serviceData.authDetails?.authType,
        username: action.payload.serviceData.authDetails?.username,
        password: action.payload.serviceData.authDetails?.password,
        authUrl: action.payload.serviceData.authDetails?.authUrl,
        headerParam: action.payload.serviceData.authDetails?.headerParam,
        requestParam: action.payload.serviceData.authDetails?.requestParam,
        queryPathParam: action.payload.serviceData.authDetails?.queryPathParam
      };
      state.serviceData.serviceName = action.payload.serviceData?.serviceName;
      state.serviceData.endPoint = action.payload.serviceData?.endPoint;
      state.serviceData.serviceType = action.payload.serviceData?.serviceType;
      state.serviceData.serviceDescription = action.payload.serviceData?.serviceDescription;
      state.serviceData.checkClicked = action.payload.serviceData?.checkClicked;
      state.serviceData.authDetails = autModel.authType?.length ? autModel : {};
      state.serviceData.soapAttributes = action.payload.serviceData?.soapAttributes;
      state.serviceExceptions = [];
      state.serviceOperations = action.payload.serviceOperations;
      state.ingressEvent = action.payload.ingressEvent;
      state.egressEvent = action.payload.egressEvent;
    },
    addAllIngressEventForDraft: (
      state,
      actions: PayloadAction<IIngressEventMappingModel[]>
    ) => {
      state.ingressEvent = [...state.ingressEvent, ...actions.payload];
    },
    addAllEgressEventForDraft: (
      state,
      actions: PayloadAction<IEgressEventMappingModel[]>
    ) => {
      state.egressEvent = [...state.egressEvent, ...actions.payload];
    },
    addAllExceptionForDraft: (
      state,
      actions: PayloadAction<IExceptionModel[]>
    ) => {
      state.serviceExceptions = [...actions.payload];
    },
    addServiceOperationForDraft: (
      state,
      actions: PayloadAction<IServiceOperation[]>
    ) => {
      state.serviceOperations = actions.payload;
    },
    clearAllSaveAsDraft: (state) => {
      state.serviceData = serviceDetails;
      state.serviceOperations = [];
      state.serviceExceptions = [];
      state.ingressEvent = [];
      state.egressEvent = [];
    },
  }
});

export const {
  addSaveAsDraft,
  addAllExceptionForDraft,
  addAllIngressEventForDraft,
  addAllEgressEventForDraft,
  clearAllSaveAsDraft,
  addServiceOperationForDraft
} = SaveAsDraftDetailsSlice.actions;
export default SaveAsDraftDetailsSlice.reducer;
